import { render } from "./Dispatcher.vue?vue&type=template&id=97a12872&scoped=true&ts=true"
import script from "./Dispatcher.vue?vue&type=script&lang=ts"
export * from "./Dispatcher.vue?vue&type=script&lang=ts"

import "./Dispatcher.vue?vue&type=style&index=0&id=97a12872&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a12872"]])

export default __exports__